<template>
  <!-- eslint-disable -->
  <div>
    <b-card no-body class="border border-2">
      <b-card-header class="d-flex justify-content-between">
        <h5>
          Filtros
          <template v-if="!see_more">
            <a class="control-label font-weight-bold text-info font-custom" @click="clickSeeMore"
              ><strong> [+ Ver más]</strong></a
            >
          </template>
          <template v-else>
            <a class="control-label font-weight-bold text-info font-custom" @click="clickSeeMore"
              ><strong> [- Ver menos]</strong></a
            >
          </template>
        </h5>
      </b-card-header>
      <b-card-body v-if="see_more">
        <b-row>          
          <b-col md="3">
            <b-form-group>
              <label for="start_date" class="fs-5 fw-semibold d-inline">
                Fecha inicio
              </label>
              <flat-pickr id="start_date" v-model="date" class="form-control" />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group>
              <label for="start_date" class="fs-5 fw-semibold d-inline">
                Fecha Final
              </label>
              <flat-pickr id="start_date" v-model="date" class="form-control" />
            </b-form-group>
          </b-col>
          <b-col md="3" class="mb-md-0 mb-2">
            <b-form-group label="Tienda" label-for="tienda">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="tipoCompro"
                label="text"
                :reduce="(tipoCompro) => tipoCompro.id"
                input-id="tienda"
              />
            </b-form-group>
          </b-col>
          <b-col md="3" class="mb-md-0 mb-2">
            <!-- @input="(val) => $emit('update:roleFilter', val)" -->
            <label>Nro Documento</label>
            <b-form-input v-model="codigo" placeholder="Nro Documento" />
          </b-col>
          <b-col md="6" class="mt-2">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-1" @click.prevent="filter">
              <feather-icon icon="SearchIcon" class="mr-50" />
              <span class="align-middle">Buscar</span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="secondary"
              class="mr-1"
              @click.prevent="clean"
            >
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span class="align-middle">Limpiar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable*/
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton, BFormGroup, BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
// import CompanyService from '@/services/CompanyService'
import flatPickr from 'vue-flatpickr-component'
export default {
  directives: {
    Ripple
  },
  data() {
    return {
      see_more: false,
      codigo: '',
      company_id: null,
      roleFilter: null,
      records: [],
      showEntrie: 10,
      arrayFilters: [],
      userData: {},
      tipoCompro:[],
      date: new Date()
    }
  },
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    flatPickr
  },
  mounted() {
    // this.getCompanys()
    // this.getData()
  },
  methods: {
    // getData(){
    //   this.userData = JSON.parse(localStorage.getItem('userData'))
    // },
    clickSeeMore() {
      this.see_more = !this.see_more
    },
    // async getCompanys() {
    //   const url = `?per_page=${this.showEntrie}&filters=${JSON.stringify(this.arrayFilters)}`
    //   const resp = await CompanyService.getCompanys(url, this.$store)
    //   console.log('respCompany', resp)
    //   if (resp) {
    //     this.records = resp.data.data
    //   }
    // },
    async filter() {
      //armar la estructura del api
      // var arrayFilter = []
      // if (this.codigo != '') {
      //   arrayFilter.push({
      //     field: 'codigo',
      //     operator: 'like',
      //     value: this.codigo
      //   })
      // }
      // if (this.company_id != null) {
      //   arrayFilter.push({
      //     field: 'company_id',
      //     operator: 'like',
      //     value: this.company_id
      //   })
      // }
      // console.log('arrayFilter', arrayFilter)
      // console.log('this.company_id', this.company_id)
      // this.$parent.$parent.arrayFilters = arrayFilter
      // await new Promise((resolve) => setTimeout(resolve, 100))
      // this.$parent.$parent.getData()
    },
    clean() {
      // this.title = ''
      // this.company_id = null
      // var arrayFilter = []
      // this.$parent.$parent.arrayFilters = arrayFilter
      // this.$parent.$parent.getData()
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
